import { useLanguage } from '@/lib/i18n/LanguageContext';
import { languages, languageNames, languageFlags, Language } from '@/lib/i18n/translations-meta';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export function LanguageSwitcher() {
  const { language, switchLanguage } = useLanguage();

  return (
    <Select value={language} onValueChange={(value) => switchLanguage(value as Language)}>
      <SelectTrigger aria-label="Select language" className="w-[48px] lg:w-[76px] bg-transparent border-none hover:bg-accent focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-md [&>svg]:hidden justify-center px-1">
        <SelectValue>
          <span className="flex items-center justify-center lg:justify-start gap-2">
            <span className="text-2xl">{languageFlags[language]}</span>
            <span className="uppercase hidden lg:inline">{language}</span>
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {languages.map((lang) => (
          <SelectItem key={lang} value={lang}>
            <span className="flex items-center gap-2">
              <span className="text-2xl">{languageFlags[lang]}</span>
              <span>{languageNames[lang]}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
